import React, { useState, useEffect } from 'react';
import { Tooltip } from '@mui/material';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import AddIcon from '@mui/icons-material/Add';
import PropTypes from 'prop-types';

const shouldForwardProp = prop => prop !== 'visible';

const NewComponentButton = styled(Button, {
  shouldForwardProp,
})(({ visible }) => ({
  opacity: visible ? 1 : 0,
  transform: visible ? 'translateX(0)' : 'translateX(-10px)',
  transition: 'opacity 0.3s ease-out, transform 0.3s ease-out',
  pointerEvents: visible ? 'auto' : 'none',
}));

const AddNewComponentButton = ({ disabled, isHovered, onClick, classes }) => {
  const [visible, setVisible] = useState(isHovered === true ? isHovered : false);

  useEffect(() => {
    if (isHovered) {
      setVisible(true);
      return;
    }

    const timeoutId = setTimeout(() => {
      setVisible(false);
    }, 250);

    return () => clearTimeout(timeoutId);
  }, [isHovered]);

  return (
    <Tooltip
      title={<span className={classes.addPathTooltipTitle}>Add Component</span>}
      placement="bottom"
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 8],
              },
            },
          ],
        },
      }}
    >
      <span>
        <NewComponentButton
          variant="outlined"
          disabled={disabled}
          className={classes.addPathButton}
          onClick={onClick}
          id="add-component-button"
          visible={visible}
        >
          <AddIcon className={classes.addPathIcon} />
        </NewComponentButton>
      </span>
    </Tooltip>
  );
};

AddNewComponentButton.propTypes = {
  disabled: PropTypes.bool,
  isHovered: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export default AddNewComponentButton;
